export default "<p>forget-password works!</p>\n";